<template>
  <div>
    <base-header class="pb-6">
      <b-row class="align-items-center py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">Group</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb/>
          </nav>
        </b-col>

        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="primary" @click="$router.back()">Back</base-button>
          <!-- <base-button size="sm" type="neutral">Filters</base-button> -->
        </b-col>
        <!--
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </b-col>
        -->
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col lg="12">
          <div class="card-wrapper">
            <!-- Input groups -->
            <card>
              <!-- Card header -->
              <h3 slot="header" class="mb-0">New Group Document Setting</h3>
              <!-- Card body -->
              <form>
                <!-- Input groups with icon -->
                <b-row>
                  <b-col md="6">
                    <base-input label="Document Type" v-if="selectOptions.length == 0">
                      <el-select v-model="selects.simple" filterable
                                  placeholder="Select Document Type">
                        <el-option value="0" disabled>-- No Available Document Type --</el-option>
                      </el-select>
                    </base-input>
                    <base-input label="Document Type" v-else>
                      <el-select v-model="selects.simple" 
                                  filterable
                                  placeholder="Select Document Type">
                        <el-option v-for="option in selectOptions"
                                    :key="option.doc_type_name"
                                    :label="option.doc_type_name"
                                    :value="option.doc_type_id">
                        </el-option>
                      </el-select>
                    </base-input>
                  </b-col>
                </b-row>

                <base-button type="primary" @click="createData()">Create</base-button>
                <base-button type="primary" @click="$router.back()">Cancel</base-button>

              </form>
            </card>

          </div>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
  import { Select , Option } from 'element-ui'
  import axios from 'axios'
  import {apiDomain, getHeader} from '@/assets/js/config.js'
  import ErrorFunctionMixin from '@/assets/js/errorFunctionMix.js'

  export default {
    mixins: [ErrorFunctionMixin],
    components:{
      [Select.name]: Select,
      [Option.name]: Option,
    },   
    data() {
      return {
        sub_id: null,
        selects:{
          simple:[]
        },
        selectOptions:[]
      }
    },
    created() {
      this.showSub()
    },
    methods: {
      createData(){
          const postData = {
            group_id : this.$route.params.id,
            doc_type_id  : this.selects.simple,
          }
          const str = JSON.stringify(postData);
          console.log(str);
          console.table(postData);

          axios.post(apiDomain + 'groups/group_document_setting', postData ,{ headers: getHeader() })
          .then ( response => {
            if (response.status === 200)
            {
              this.$notify({
                message:
                  '<b>Add Doc Type : ' + response.data.data[0].group_name + '</b> - Successfully Created.',
                timeout: 10000,
                icon: 'ni ni-bell-55',
                type: 'default',
              });
              this.$router.back()

            }
          })
          .catch ( error => {
              console.log(error.response.status)
              this.errorFunction(error, "Add Group Doc Type")
              
          });
        
      },
      docTypeList(){
        axios.get(apiDomain + 'setup/document_type.show_by_group/' + this.$route.params.id, { headers: getHeader() })
        .then(response => {
          this.selectOptions = response.data.data
        })
        .catch ( error => {
            console.log(error.response.status)
            this.errorFunction(error, "Add Group Doc Type")
            
        });
          
      },
      showSub(){
        axios.get(apiDomain + 'groups/group/' + this.$route.params.id , { headers: getHeader() })
        .then(response => {
          this.sub_id = response.data.data[0].sub.sub_id
          this.docTypeList()

          const str = JSON.stringify(response.data.data[0], null, 2);
          console.log(str);
        })
        .catch ( error => {
            console.log(error.response.status)
            this.errorFunction(error, "Add Group Doc Type")
            
        });
      }
    }
  }
</script>
